import { SamcartInterface } from '../interfaces';
import Axios from "../libraries/axios";

class SamcartModel implements SamcartInterface {
	[key: string]: any
	internalPatientId = '';
	payload = {};
	createdAt = new Date();

	constructor(props: SamcartInterface) {
	  if (props) {
	    Object.assign(this, props);
	  }
	}

	static async getUserTransactions(id: string): Promise<any> {
	  const { data } = await Axios.get(`/api/samcart-events?internalPatientId=${id}&$sort[createdAt]=-1`);
	  return data;
	}
}

export default SamcartModel;
